import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { LANGS, Lang } from '../i18n/translations';
export function LanguageSwitcher() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const current = LANGS.find(l => l.code === lang) ?? LANGS[0];
  const select = (code: Lang) => {
    setLang(code);
    setIsOpen(false);
  };
  return <div className="relative" ref={ref} data-id="element-136" data-mp="n6i8j8qg56gk">
      <button type="button" onClick={() => setIsOpen(v => !v)} aria-label={t.nav.language} aria-haspopup="listbox" aria-expanded={isOpen} className="flex items-center gap-1 px-2 py-1 rounded-md border border-white/15 text-white/70 hover:text-[#38bdf8] hover:border-[#38bdf8]/40 transition-colors text-[11px] font-medium tracking-wider" data-id="element-137" data-mp="n7jif9vq7mwp">
        <Globe size={12} className="opacity-70" data-id="element-138" data-mp="1yotquptoho5u" />
        {current.label}
        <ChevronDown size={12} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-139" data-mp="2w9pu06k0eku9" />
      </button>

      <AnimatePresence data-id="element-140" data-mp="2mky4e52f8cmi">
        {isOpen && <motion.ul role="listbox" initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.15
      }} className="absolute right-0 mt-1 w-16 overflow-hidden rounded-md border border-white/10 bg-[#0a1628]/95 backdrop-blur-md shadow-xl z-50" data-id="element-141" data-mp="2mjmzu315j0uc">
            {LANGS.map(option => <li key={option.code} role="option" aria-selected={option.code === lang} data-id="element-142" data-mp="18dry7tvwnim9">
                <button type="button" onClick={() => select(option.code)} className={`w-full text-left px-3 py-1.5 text-[11px] font-medium tracking-wider transition-colors ${option.code === lang ? 'text-[#38bdf8] bg-[#38bdf8]/10' : 'text-white/60 hover:text-white hover:bg-white/5'}`} data-id="element-143" data-mp="1ce265c39cj3r">
                  {option.label}
                </button>
              </li>)}
          </motion.ul>}
      </AnimatePresence>
    </div>;
}